import { gsap } from "gsap";
export default function Heros() {

}

//window.onload = function () {
    if (document.querySelector('.hero-brushstroke')) {
        runAnimateFirst();
        setTimeout(function () {
            runAnimate();
        }, 1000);
    } else {
        noAnimate();
    }

    if(document.querySelector('.hero-shakeitup')) {
        setTimeout(function () {
            runShakeItUp();
        }, 1000);
    }
//};

function noAnimate() {
    var headerInner = document.querySelector('.header__inner');
    if (window.innerWidth > 980) {
        headerInner.classList.add('visible');
    }
}

function runAnimateFirst() {
    var heroImageContainer = document.querySelector('.hero__background-image');
    var heroImageSpinner = document.querySelector('.js-image-spinner');

    if (window.innerWidth > 980) {
        if (heroImageContainer) {
            heroImageContainer.classList.add('scale-in');
        }
        if (heroImageSpinner) {
            heroImageSpinner.classList.add('hidden');
        }
    }
}

function runAnimate() {
        var left = document.querySelector('.left-stroke');
        var right = document.querySelector('.right-stroke');
        var bottom = document.querySelector('.right-bottom-stroke');
        var mainContent = document.querySelector('.brushstroke-content');
        var linkContent = document.querySelector('.hero-icons-desktop');
        var headerInner = document.querySelector('.header__inner');

        if (window.innerWidth > 980) {
            left.classList.add('slide-down');
            right.classList.add('slide-down');
            mainContent.classList.add('slide-right');
            if (linkContent) {
                linkContent.classList.add('slide-up');
            }

            headerInner.classList.add('slide-down');
            if (bottom != null) {
                bottom.classList.add('slide-from-right');
            }
        }
}

const randomInRange = (min, max) => Math.random() * (max - min) + min

function runShakeItUp() {
    const secondImage = document.querySelector('.shakeitup-image-2');
    const text = document.querySelector('.shakeitup-text');

    secondImage.classList.add('is-shown')
    text.classList.add('is-shown')
    

    const gsapElem = '.shakeitup-inner'
    const gsapChip = '.shakeitup-chip'
    const gsapButton = '.shakeitup-button'
    const gsapFooter = '.shakeitup-footer'

    const tl = gsap.timeline({ repeat: 0 });
    let step = 0

    if (document.querySelector('.hero-shakeitup.shake-off')) {

        tl.to(gsapButton, {
            opacity: 1,
            scale: 1,
            duration: 1.5,
            ease: "elastic.out(0.5, 0.2)",
        }).fromTo(gsapChip, {
            bottom: '-300px',
            rotate: "13deg",
        }, {
            bottom: 0,
            duration: 1.5,
            ease: "elastic.out(1, 0.5)",
            onStart: () => {
                gsap.to(gsapChip, {
                    rotate: "0deg",
                    delay: 0.05,
                    duration: 0.25,
                })
            }
        }, 1).to(gsapFooter, {
            bottom: '35px',
            duration: 1.5,
            ease: "elastic.out(0.5, 0.2)",
        }, 1.3);


        return;
    }

  


    if (window.innerWidth > 980) {
        tl.to(gsapElem, {
            duration: 0.35,
            scale: 1.15,
            filter: "blur(4px)",
            ease: "power1.inOut",
            onUpdate: function() {
                setTimeout(() => {
                    const range = 4*step
                    gsap.to(gsapElem, {
                        duration: 0.015,
                        x: () => randomInRange(-range, range),
                        y: () => randomInRange(-range, range),
                        ease: "none"
                    });
                    step++
                }, 70)
            }
        }).to(gsapElem, {
            duration: 0.35,
            scale: 1,
            filter: "blur(0)",
            ease: "power1.inOut",
            onUpdate: function() {
                const range = 4*step
                gsap.to(gsapElem, {
                    duration: 0.015,
                    x: () => randomInRange(-range, range),
                    y: () => randomInRange(-range, range),
                    ease: "none"
                });
                step--
                if(step < 0) step = 0
            },
            onComplete: function() {
                setTimeout(() => {
                    gsap.to(gsapElem, {
                        duration: 0,
                        x: 0,
                        y: 0,
                        ease: "none"
                    });
                }, 100)
            }
        }).to(gsapButton, {
            opacity: 1,
            scale: 1,
            duration: 1.5,
            ease: "elastic.out(0.5, 0.2)",
        }).fromTo(gsapChip, {
            bottom: '-300px',
            rotate: "13deg",
        }, {
            bottom: 0,
            duration: 1.5,
            ease: "elastic.out(1, 0.5)",
            onStart: () => {
                gsap.to(gsapChip, {
                    rotate: "0deg",
                    delay: 0.05,
                    duration: 0.25,
                })
            }
        }, 1).to(gsapFooter, {
            bottom: '35px',
            duration: 1.5,
            ease: "elastic.out(0.5, 0.2)",
        }, 1.3);
    } else {
        tl.to(gsapElem, {
            duration: 0.35,
            scale: 1.1,
            filter: "blur(4px)",
            ease: "power1.inOut",
            onUpdate: function() {
                setTimeout(() => {
                    const range = 4*step
                    gsap.to(gsapElem, {
                        duration: 0.015,
                        x: () => randomInRange(-range, range),
                        y: () => randomInRange(-range, range),
                        ease: "none"
                    });
                    step++
                }, 70)
            }
        }).to(gsapElem, {
            duration: 0.35,
            scale: 1,
            filter: "blur(0)",
            ease: "power1.inOut",
            onUpdate: function() {
                const range = 4*step
                gsap.to(gsapElem, {
                    duration: 0.015,
                    x: () => randomInRange(-range, range),
                    y: () => randomInRange(-range, range),
                    ease: "none"
                });
                step--
                if(step < 0) step = 0
            },
            onComplete: function() {
                setTimeout(() => {
                    gsap.to(gsapElem, {
                        duration: 0,
                        x: 0,
                        y: 0,
                        ease: "none"
                    });
                }, 100)
            }
        }).to(gsapButton, {
            opacity: 1,
            scale: 1,
            duration: 1.5,
            ease: "elastic.out(0.5, 0.2)",
        }).fromTo(gsapChip, {
            bottom: '-200px',
            rotate: "13deg",
        }, {
            bottom: '0',
            duration: 1.5,
            ease: "elastic.out(0.5, 0.2)",
            onStart: () => {
                gsap.to(gsapChip, {
                    rotate: "0deg",
                    delay: 0.05,
                    duration: 0.25,
                })
            }
        }, 1).to(gsapFooter, {
            bottom: '16px',
            duration: 1.5,
            ease: "elastic.out(0.5, 0.2)",
        }, 1.3);
    }
}

